import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M20 4 3 21l30 29L3 80l17 17 29-30 30 30 16-17-30-30 30-30L80 4 50 34z",
      style: {"fill":"currentColor","stroke":"#222","stroke-width":"4"}
    }, null, -1)
  ])))
}
export default { render: render }